export default defineNuxtPlugin(() => {
  const stores = [useActionsStore(), useArticlesStore()]

  for (const store of stores) {
    try {
      JSON.stringify(store.$state)
    } catch (e) {
      console.error(`🚨 Serialization failed in store: ${store.$id}`, e)
    }
  }
})
